import { render, staticRenderFns } from "./GestaoEmailsAutomaticosPage.vue?vue&type=template&id=4ebe60b6&scoped=true"
import script from "./GestaoEmailsAutomaticosPage.vue?vue&type=script&lang=js"
export * from "./GestaoEmailsAutomaticosPage.vue?vue&type=script&lang=js"
import style0 from "./GestaoEmailsAutomaticosPage.vue?vue&type=style&index=0&id=4ebe60b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe60b6",
  null
  
)

export default component.exports